import { render } from "./Live.vue?vue&type=template&id=926f1020"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dominik/Development/Websites/elite-partner.gui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__